import React from "react";
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import {withStyles} from "@material-ui/core";
import OrderItem, {getStatus} from "../Components/OrderItem";
import {
    action_order,
    action_order_list,
    apiURL, contractId,
    CORSSupport,
    userID,
    userLogin,
    userPassword
} from "../configurationConstant";
import {
    clearOrder,
    setMeanTime,
    setOrder,
    setOrderBefore, setOrderItem,
    setOrderNow
} from "../store/actions/order_actions";
import {connect} from "react-redux";
import {getStep} from "./OrderIDPage";

const search_icon = require("../images/ICON.png");

const Form = withStyles({
    root: {
        display: 'flex',
        background: '#E8EFF2',
        textAlign: 'left',
        padding:0,
        height:32,
        border: '1px solid rgba(0, 0, 0, 0.12)',
        boxSizing: 'border-box',
        borderRadius: 7
},
})(FormControl);
const Selects = withStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        background: '#E8EFF2',
        margin: '0 15px',
        textAlign: 'left',
        fontStyle: 'normal',
        fontWeight: 300,
        fontSize: 16,
        lineHeight: 19,
        height:30,
        padding: 0,
        border: 'none',
        outline:'none'
    },
    icon: {
        fill: "white",
    },
})(Select);

class AllOrder extends React.Component{
    constructor(props){
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.filterRequests = this.filterRequests.bind(this);
        this.getRequest = this.getRequest.bind(this);
        this.setLoadedRequests = this.setLoadedRequests.bind(this);
        this.getOrderValue = this.getOrderValue.bind(this);
        this.state ={
            search_type: 0,
            requests: [],
            visible_request: [],
            sorted_order: [],
            search_name: '',
            order_items: []
        };

    }

    componentDidMount(): void {
        this.getRequest()
    }

    filterRequests = (event) => {
        let array = this.state.sorted_order;
        if (event.target.value !== '') {
            array = array.filter(function (item) {
                return Number(item.number) === Number(event.target.value)
            });
            this.setState({
                visible_request: array.slice(0,6),
                search_name: event.target.value
            })
        }
        else
            if(this.state.search_type === 0){
                this.setState({
                    visible_request: this.state.requests.slice(0,6),
                    sorted_order: this.state.requests,
                    search_name: event.target.value
                })
            }
            else
                this.setState({
                    visible_request: array.slice(0,6),
                    search_name: event.target.value
                })
    };

    setLoadedRequests(){
        this.setState({
            visible_request: this.state.sorted_order.slice(0,this.state.visible_request.length+6)
        })
    }

    getRequest(){
        let headers = new Headers();
        headers.append('Content-Type','application/x-www-form-urlencoded');
        fetch( apiURL  , {
            method: "post",
            headers: headers,
            body: 'action=' + action_order_list + '&contract=' + contractId + '&log='+userLogin+'&pwd='+userPassword+'&user=' + userID,
            mode: 'cors',
        }).then(r => {
            this.props.clearOrder();
            if (r.status === 200)
                return r.json().then((data) => {
                    let now_month = getMonth(new Date().getMonth()).month;
                    let last_month = getMonth(new Date().getMonth()-1).month;
                    let now = 0;
                    let last = 0;
                    this.setState({
                        requests: data,
                        sorted_order: data,
                        visible_request: data.slice(0,6)
                    });
                    let time = 0;
                    let ready_order = 0;
                    data.forEach(function (item) {
                        if (String(item.order_complete_date).split(" ")[0] !== "null" &&
                            String(item.order_complete_date).split(" ")[0] !== null){
                            ready_order ++;
                            let date = (item.order_complete_date).split(" " );
                            if (Number(date[0].split("-")[1])  === now_month)
                                now++;
                            else if(Number(date[0].split("-")[1])  === last_month)
                                last++;
                            let date_create = (item.order_create_date).split(" " );
                            let milliseconds = new Date(Number(date[0].split("-")[0]),Number(date[0].split("-")[1]) -1, Number(date[0].split("-")[2]),
                                Number(date[1].split(":")[0]),Number(date[1].split(":")[1]),Number(date[1].split(":")[2])) -
                                new Date(Number(date_create[0].split("-")[0]),Number(date_create[0].split("-")[1]) -1, Number(date_create[0].split("-")[2]),
                                    Number(date_create[1].split(":")[0]),Number(date_create[1].split(":")[1]),Number(date_create[1].split(":")[2]));
                            time += milliseconds/60000
                        }
                        else if( item.order_complete_date == null || item.order_complete_date == undefined || item.order_complete_date  === '' ){
                            now++;
                        }
                    });
                    if (ready_order !== 0)
                        this.props.setMeanTime(time/ready_order);
                    this.props.setOrderNow(now);
                    this.props.setOrderBefore(last);
                    data.forEach(item =>{
                        this.getOrderValue(item.orderid)
                    })
                })
        }).catch(r => console.log(r));
    }

    getOrderValue(ID){
        let headers = new Headers();
        headers.append('Content-Type','application/x-www-form-urlencoded');
        fetch( apiURL  , {
            method: "post",
            headers: headers,
            body: 'action=' + action_order + '&contract=1&log=' + userLogin + '&pwd=' + userPassword +
                '&user=' + userID + '&order='+ ID ,
            mode: 'cors',
        }).then(r => {
            if (r.status === 200)
                return r.json().then((data) => {
                    let price = 0;
                    let count = 0;
                    if (Array.isArray( data.details))
                        data.details.forEach(function (item) {
                            let id = item.catalogid;
                            item.services[id].forEach(el =>{
                                price += Number(el.service_price * el.count_order);
                                count += Number( el.count_order);
                            })
                        });
                    this.props.setOrder({orderid: data.orderid, status: getStep(data.status), express: count, priming: count, price: price});
                    this.props.setOrderItem({orderid: data.orderid, price: price, count: count, status: getStatus(data.status)});
                })
        }).catch(r => console.log(r));
    }

    setSortedArray(type){
        let array = this.state.requests;
        if (type !== 0) {
            array = array.filter((item) => {
                if (this.state.search_name === '')
                    return getStep(item.status).status === type;
                else {
                    return (getStep(item.status).status === type && item.number === this.state.search_name);
                }
            });
            this.setState({
                visible_request: array.slice(0, 6),
                sorted_order: array
            });
        }
        else {
            if (this.state.search_name === '')
                this.setState({
                    visible_request: array.slice(0, 6),
                    sorted_order: array
                 });
            else {
                this.setState({
                    visible_request: array.filter(item => {return item.number === this.state.search_name}).slice(0, 6),
                    sorted_order: array.filter(item => {return item.number === this.state.search_name})
                });
            }
        }
    }

    handleChange = (event) => {
        this.setState({search_type: event.target.value});
        this.setSortedArray(event.target.value);
    };

    render() {
        return(
            <main id={"requests"}>
                <div id={"title_container_mobile"} className={"title_container"}>
                    <p>Заявки</p>
                </div>
                <div>
                    <div className={'order_filter'}>
                        <div id={"title_container_desktop"} className={"title_container"}>
                            <p>Заявки</p>
                        </div>
                        <label htmlFor={"search_field"} className={'search'}>
                            <svg className={'search_field_mobile_icon'} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.5 0C8.22391 0 9.87721 0.684819 11.0962 1.90381C12.3152 3.12279 13 4.77609 13 6.5C13 8.11 12.41 9.59 11.44 10.73L11.71 11H12.5L17.5 16L16 17.5L11 12.5V11.71L10.73 11.44C9.55055 12.4468 8.05071 12.9999 6.5 13C4.77609 13 3.12279 12.3152 1.90381 11.0962C0.684819 9.87721 0 8.22391 0 6.5C0 4.77609 0.684819 3.12279 1.90381 1.90381C3.12279 0.684819 4.77609 0 6.5 0ZM6.5 2C4 2 2 4 2 6.5C2 9 4 11 6.5 11C9 11 11 9 11 6.5C11 4 9 2 6.5 2Z" fill="black" fillOpacity="0.12"/>
                            </svg>
                            <img className={'search_field_desktop_icon'} src={search_icon} alt={'icon'}/>
                           <input id={"search_field"} placeholder={'Поиск по заявкам'} type={"text"} onChange={this.filterRequests}/>
                        </label>
                        <Form>
                            <Selects
                                id={"select_field"}
                                disableUnderline
                                value={this.state.search_type}
                                onChange={this.handleChange}
                            >
                                <MenuItem disabled>Статус</MenuItem>
                                <MenuItem value={0}>Все заявки</MenuItem>
                                <MenuItem value={1}>Создание</MenuItem>
                                <MenuItem value={2}>Обработка</MenuItem>
                                <MenuItem value={3}>Выполнение</MenuItem>
                                <MenuItem value={4}>Оплата</MenuItem>
                                <MenuItem value={5}>Завершена</MenuItem>
                            </Selects>
                        </Form>
                    </div>
                    <div>
                        <div>
                            <div id={'order_table'}>
                                <div className={'order_table_title'}>
                                    <p>Заявка</p>
                                    <p>Дата размещения</p>
                                    <p>Дата завершения</p>
                                    <p>Сумма ₽</p>
                                    <p>Статус</p>
                                </div>
                                {(Array.isArray(this.state.visible_request) && this.state.visible_request.length > 0) && this.state.visible_request.map((request) => (
                                    <OrderItem data={request} key={request.number}/>))}
                                </div>
                            </div>
                    </div>
                    {this.state.visible_request.length >= 6 && this.state.sorted_order.length > this.state.visible_request.length? (
                        <div className={'load_request_button'}>
                            <button onClick={() => this.setLoadedRequests()}>
                                <p>Загрузить еще</p>
                            </button>
                        </div>
                    ):undefined}
                </div>
            </main>
        )
    }
}

export function getMonth(month) {
    switch (month) {
        case 0:
            return {month: 1, name: 'Январь'};
        case 1:
            return {month: 2, name: 'Февраль'};
        case 2:
            return {month: 3, name: 'Март'};
        case 3:
            return {month: 4, name: 'Апрель'};
        case 4:
            return {month: 5, name: 'Май'};
        case 5:
            return {month: 6, name: 'Июнь'};
        case 6:
            return {month: 7, name: 'Июль'};
        case 7:
            return {month: 8, name: 'Август'};
        case 8:
            return {month: 9, name: 'Сентябрь'};
        case 9:
            return {month: 10, name: 'Октябрь'};
        case 10:
            return {month: 11, name: 'Ноябрб'};
        case 11:
            return {month: 12, name: 'Декабрь'};
        default:
            return {month: 12, name: 'Декабрь'};

    }
}
const mapStateToProps = store => {
    return{
        cart: store.cart,
        order: store.order
    }
};

const mapDispatchToProps = dispatch => {
    return{
        setOrder: (order) => dispatch(setOrder(order)),
        clearOrder: () => dispatch(clearOrder()),
        setMeanTime: (time) => dispatch(setMeanTime(time)),
        setOrderBefore: (order) => dispatch(setOrderBefore(order)),
        setOrderNow: (order) => dispatch(setOrderNow(order)),
        setOrderItem: (order) => dispatch(setOrderItem(order)),
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(AllOrder)
